export interface FormatPhoneNumbersForTTSOptions {
	zeroAsOh?: boolean;
	style?: 'spaced' | 'hyphenated' | 'comma';
	appendPeriod?: boolean;
	addSpaceAfter?: boolean;
}

function stripHtmlAndLinks(html: string): string {
	// Remove all HTML tags
	let text = html.replace(/<[^>]+>/g, ' ');

	// Remove URLs
	text = text.replace(/https?:\/\/\S+/g, ' ');

	// Collapse multiple spaces
	text = text.replace(/\s+/g, ' ').trim();

	return text;
}


/**
 * Converts digit sequences into fully reliable TTS-friendly spoken words.
 * Preserves all blocks and digits; last digit is never skipped.
 */
export function formatPhoneNumbersForTTS(
	text: string,
	options: FormatPhoneNumbersForTTSOptions = {},
): string {
	const cleanedText = stripHtmlAndLinks(text); // preprocess HTML & links

	const digitWords: Record<string, string> = {
		'0': options.zeroAsOh ? 'oh' : 'zero',
		'1': 'one',
		'2': 'two',
		'3': 'three',
		'4': 'four',
		'5': 'five',
		'6': 'six',
		'7': 'seven',
		'8': 'eight',
		'9': 'nine',
	};

	const formatStyle = options.style ?? 'spaced';
	const appendPeriod = options.appendPeriod ?? true;
	const addSpaceAfter = options.addSpaceAfter ?? true;

	// Match digit sequences
	const numberRegex = /\d[\d\s\-()]{2,}\d/g;

	// Apply number replacement on cleaned text
	const spoken = cleanedText.replace(numberRegex, (match: string): string => {
		const blocks = match.split(/[^\d]+/).filter(Boolean);
		if (!blocks.length) { return match; }

		const wordBlocks = blocks.map((block) =>
			block
				.split('')
				.map((d) => digitWords[d as keyof typeof digitWords])
				.join(formatStyle === 'hyphenated' ? '-' : ' '),
		);

		const joined = wordBlocks.join(', ');
		let result = `"${joined}"`;
		if (appendPeriod) { result += '.'; }
		if (addSpaceAfter) { result += ' '; }

		return result;
	});

	return spoken; // now using cleanedText
}

